import { Box } from "@mui/material";
import { Grid } from "@mui/material";
import IDMELogo from "../../../images/icons/IDme.svg";
import { Typography } from "@mui/material";
import { primaryColor } from "../../../Theme";
import DigitalRxLogo from "../../../images/icons/DRxLogo.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function Success() {
  return (
    <>
      <Grid container spacing={2} height={400}>
        <Grid item xs={12}>
          <Box className="logos">
            <img src={IDMELogo} alt="ID.me" height={30} />
            <Typography
              component={"div"}
              color={"slategrey"}
              margin={0}
              padding={0}
              variant={"h3"}
              fontWeight={600}
            >
              +
            </Typography>
            <img src={DigitalRxLogo} alt="Digital Rx" height={30} />
          </Box>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Box className={"success"}>
            <CheckCircleIcon color="success" sx={{ height: 60, width: 60 }} />
            <Typography
              color={primaryColor}
              component={"div"}
              margin={0}
              padding={0}
              variant={"subtitle1"}
              fontWeight={600}
            >
              Your authentication request has been Approved
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
